import { array, mixed, object, string } from 'yup';

import { validatePhoneNumber, validateTelecomId } from '@utils/validation';

import { EOrganizationType, TOrganizationType } from '@enums/common';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_10_LENGTH, MAX_50_LENGTH, MAX_70_LENGTH } from '@constants/validationMessages';

export const schema = object({
	name: string()
		.trim()
		.default('')
		.max(MAX_50_LENGTH, getMaxLengthErrMsg('Organisation Name', MAX_50_LENGTH))
		.required(validationErrMessages.name),
	legalName: string()
		.trim()
		.default('')
		.max(MAX_70_LENGTH, getMaxLengthErrMsg('Organisation Legal Name', MAX_70_LENGTH))
		.required(validationErrMessages.legalName),
	url: string()
		.trim()
		.default(''),
	email: string()
		.trim()
		.email(validationErrMessages.validEmail)
		.default(''),
	contactNumber: string()
		.default('')
		.test('validatePhoneNumber', validationErrMessages.contactNumber, validatePhoneNumber),
	companyNumber: string()
		.trim()
		.default('')
		.max(MAX_10_LENGTH, getMaxLengthErrMsg('CRN', MAX_10_LENGTH)),
	property: string()
		.trim()
		.default('')
		.max(MAX_50_LENGTH, getMaxLengthErrMsg('Property No./Name', MAX_50_LENGTH)),
	streetName: string()
		.trim()
		.default('')
		.max(MAX_50_LENGTH, getMaxLengthErrMsg('Street Name', MAX_50_LENGTH)),
	locality: string()
		.trim()
		.default('')
		.max(MAX_50_LENGTH, getMaxLengthErrMsg('Locality', MAX_50_LENGTH)),
	city: string()
		.trim()
		.default('')
		.max(MAX_50_LENGTH, getMaxLengthErrMsg('Town/City', MAX_50_LENGTH)),
	postcode: string()
		.trim()
		.default('')
		.max(MAX_10_LENGTH, getMaxLengthErrMsg('Postcode', MAX_10_LENGTH))
		.required(validationErrMessages.postcode),
	country: object()
		.nullable()
		.required(validationErrMessages.country),
	categoryIds: array().nullable(),
	types: array().required(),
	organizationTelecomId: mixed().when('types', {
		is: (types: Array<TOrganizationType>) => types.some((value) => {
			return value === EOrganizationType.networkOperator;
		}),
		then: string()
			.trim()
			.max(MAX_50_LENGTH, getMaxLengthErrMsg('Organisation Telecom ID', MAX_50_LENGTH))
			.test('validateId', 'Numbers, letters and -, _ are allowed only.', validateTelecomId)
			.required(validationErrMessages.organisationTelecomId),
		otherwise: string().nullable().notRequired(),
	}),
	timezone: object()
		.nullable()
		.required(validationErrMessages.timezone),
});
